import { Api } from "../axios-config";

import { GetPersonDataByDocumentResponseDto } from "./dtos/get-person-data-by-document-response.dto";
import { IPeopleCreate, IPeopleListResponseDto, PeopleTotal } from "./types";

const getPersonDataByDocument = async (document: string): Promise<GetPersonDataByDocumentResponseDto> => {
	const response = await Api().get(`/people/by-document/${document}`);
	return response.data;
};

const getAll = async (page = 1, limit = 10, busca = "", status = "Todos"): Promise<PeopleTotal | Error> => {
	try {
		const urlRelativa = `/people-negative?_page=${page}&_limit=${limit}&nome_like=${busca}&status=${status}`;
		const { data, headers } = await Api().get(urlRelativa);

		if (data.results) {
			return {
				data: data.results,
				totalCount: data.total,
			};
		}
		return new Error("Erro ao listar registros.");
	} catch (error) {
		console.error(error);
		return new Error((error as { message: string }).message || "Erro ao listar registros.");
	}
};

const getById = async (id: string): Promise<IPeopleListResponseDto | Error> => {
	try {
		const { data } = await Api().get(`/people-negative/${id}`);

		if (data) {
			return data;
		}
		return new Error("Erro ao consultar o registro.");
	} catch (error) {
		console.error(error);
		return new Error((error as { message: string }).message || "Erro ao consultar o registro.");
	}
};

const create = async (dados: Omit<IPeopleCreate, "id">): Promise<any> => {
	try {
		const { data } = await Api().post<IPeopleListResponseDto>("/people-negative", dados);

		if (data) return data.id;

		return new Promise((_, reject) => reject(new Error("Erro ao criar o registro.")));
	} catch (error: any) {
		console.error(error);
		return new Promise((_, reject) => reject(error));
	}
};

const updateById = async (id: string, dados: IPeopleCreate): Promise<void | Error> => {
	try {
		await Api().patch(`/people-negative/${id}`, dados);
	} catch (error) {
		console.error(error);
		return new Error((error as { message: string }).message || "Erro ao atualizar o registro.");
	}
};

export const PeopleService = {
	getPersonDataByDocument,
	getAll,
	getById: getById,
	create,
	updateById,
};
